import {useMemo} from 'react'
import {useLocation} from 'react-router-dom'
import {Nullable} from '../../../Common/TypeHelper'

export const UrlQueryParams = {
  status: {
    ok: 'OK',
    canceled: 'Canceled',
    paymentSystemError: 'Payment System Error',
  },
}

export const useQuery = (param: keyof typeof UrlQueryParams): Nullable<string> => {
  const {search} = useLocation()

  const query = useMemo(() => new URLSearchParams(search), [search])

  return query.get(param)
}
